import { FolderTemplateOption, FolderTemplateFormatId, FolderTemplateFormatName } from "@common/dto/folder-settings";

export const folderTemplateOptionKeys: Array<keyof FolderTemplateOption> = [
    "tempIds",
    "tempPds",
    "tempSubtext",
    "tempSymbols",
    "tempAddText",
    "tempSmartDrawDims",
    "tempPedProperties",
    "tempPedDropFields",
    "tempHeader",
    "tempFooter"
];

export const defaultFormatIdKeys: Array<keyof FolderTemplateFormatId>  = [
    "defaultIdsFormatId",
    "defaultPdsFormatId",
    "defaultSubtextFormatId",
    "defaultSymbolsFormatId",
    "defaultPedDropFormatId",
    "defaultHeaderFormatId",
    "defaultFooterFormatId",
];

export const defaultFormatNameKeys: Array<keyof FolderTemplateFormatName>  = [
    "defaultIdsFormatName",
    "defaultPdsFormatName",
    "defaultSubtextFormatName",
    "defaultSymbolsFormatName",
    "defaultPedDropFormatName",
    "defaultHeaderFormatName",
    "defaultFooterFormatName",
];